import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import IconButton from "material-ui/IconButton";
import { red500 } from "material-ui/styles/colors";
import ActionUpdate from "material-ui/svg-icons/editor/mode-edit";
import ActionDelete from "material-ui/svg-icons/action/delete";
import ActionView from "material-ui/svg-icons/action/visibility";
import { GridList, GridTile } from "material-ui/GridList";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui/Table";
import RaisedButton from "material-ui/RaisedButton";
import * as actions from "../actions/restaurants.actions";
import ProgressIndicator from "../components/ProgressIndicator";
import RestaurantCard from "../components/RestaurantCard";
import Settings from "../pages/Settings";
import { browserHistory, Link } from "react-router";

const styles = {
  root: {
    padding: 20,
    margin: "0 auto",
  },
  gridList: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
};

class Restaurants extends Component {
  componentDidMount() {
    this.props.fetchRestaurants();
  }

  renderRestaurants() {
    return (
      <Table
        selectable={false}
        onCellClick={(row, col) =>
          browserHistory.push(`/${this.props.restaurants[row].id}`)
        }
      >
        <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
          <TableRow>
            <TableHeaderColumn>Name</TableHeaderColumn>
            <TableHeaderColumn>Photo</TableHeaderColumn>
            <TableHeaderColumn></TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {this.props.restaurants.map((restaurant, key) => (
            <TableRow key={key}>
              <TableRowColumn>{restaurant.name}</TableRowColumn>
              <TableRowColumn>
                <img
                  src={restaurant.photo ? restaurant.photo : ""}
                  style={{ width: 85, height: 64 }}
                />
              </TableRowColumn>
              <TableRowColumn>
                <IconButton on>
                  <ActionView />
                </IconButton>
              </TableRowColumn>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  onRestaurantCreated = (restaurantId) => {
    browserHistory.push(`/${restaurantId}`);
  };

  render() {
    if (this.props.isLoading) return <ProgressIndicator />;

    if (_.isEmpty(this.props.restaurants))
      return <Settings create={true} onCreated={this.onRestaurantCreated} />;

    return (
      <div style={styles.root}>
        <h1>Restaurants</h1>
        <RaisedButton
          label="Create Restaurant"
          style={{ marginBottom: 15 }}
          secondary
          onClick={() => this.props.router.push(`/create-restaurant`)}
        />
        <div style={styles.gridList}>{this.renderRestaurants()}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  console.log({ state });
  return {
    restaurants: createRestaurantListWithId(state.restaurants.restaurantList),
    isLoading: state.restaurants.loading,
  };
}

function createRestaurantListWithId(restaurantList) {
  function appendId(value, key, object) {
    return {
      ...value,
      id: key,
    };
  }
  let restaurantsWithIds = _.mapValues(restaurantList, appendId);
  return _.sortBy(restaurantsWithIds, "name");
}
export default connect(mapStateToProps, actions)(Restaurants);



// WEBPACK FOOTER //
// ./src/pages/Restaurants.js